export const ga = (...args) =>
  (typeof window?.['ga'] === 'function') && window['ga'](...args)
